import { forwardRef } from 'react';
import { FiCheckCircle, FiCircle } from 'react-icons/fi';
import styles from './QuizQuestionCard.module.css';

const QuizQuestionCard = forwardRef(({ index, isAnswered, isActive, onClick }, ref) => {
  return (
    <button
      ref={ref}
      className={`${styles.card} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.text}>
        Question {index + 1}
      </div>
      {isAnswered ? (
        <FiCheckCircle className={styles.checkIcon} />
      ) : (
        <FiCircle className={styles.checkIcon} />
      )}
    </button>
  );
});

export default QuizQuestionCard;